// eslint-disable-next-line no-restricted-imports
import RollbarInstance from 'rollbar';

const sentExceptions: string[] = [];

/**
 * Check if new exception is repeated.
 * If not, put it into an array for duplicated check.
 */
function shouldIgnoreNewException(exception: string): boolean {
  // Ignore duplicated exception
  if (sentExceptions.includes(exception)) {
    return true;
  }

  // Log the known exception
  sentExceptions.push(exception);
  return false;
}

const Rollbar = new RollbarInstance({
  verbose: import.meta.env.MODE === 'staging',
  accessToken: import.meta.env.VITE_ROLLBAR_CLIENT_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: 'anonymize',
  maxItems: 30,
  itemsPerMinute: 10,
  payload: {
    environment: import.meta.env.MODE,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: import.meta.env.VITE_CODE_VERSION,
        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
  checkIgnore(isUncaught, args, payload) {
    /**
     * Should contains any content
     */
    if (args.length === 0) {
      return true;
    }

    const firstLineOfErrorStack = JSON.stringify(
      // @ts-expect-error FIXME:
      payload?.body?.trace?.frames?.[0] ?? '',
    );

    /**
     * Handle uncaught error
     */
    if (isUncaught) {
      const err = args[1];

      // Ignore if error instance is not found
      if (!(err instanceof Error)) {
        return true;
      }

      /**
       * Ignore those errors without trace stack
       */

      // TODO: reopen when rollbar issues are stable
      // @ts-expect-error FIXME:
      if (payload?.body?.trace?.frames?.length === 0) {
        return true;
      }

      // Ignore uncaught error that not caused by our SDK
      if (!firstLineOfErrorStack.includes('rmn-web-sdk.js')) {
        return true;
      }
    }
    return shouldIgnoreNewException(firstLineOfErrorStack);
  },
});

export default Rollbar;
